<template>
    <v-btn
        :id="name"
        :variant="buttonStyle.variant"
        :color="buttonStyle.color"
        rounded="xs"
        :class="['custom-button', buttonStyle.classes, $attrs.class]"
        :disabled="disabled || loading"
        :prepend-icon="typeof prependIcon === 'string' ? prependIcon : undefined"
        :append-icon="typeof appendIcon === 'string' ? appendIcon : undefined"
        :loading="loading"
        :size="size"
        :type="type"
        :name="name"
        @click="handleButtonClick($event)"
    >
        <template v-if="typeof prependIcon === 'function'" #prepend>
            <component :is="prependIcon" size="18" />
        </template>
        <slot></slot>
        <template v-if="typeof appendIcon === 'function'" #append>
            <component :is="appendIcon" size="18" />
        </template>
    </v-btn>
</template>

<script>
import { useExpertStore } from '@/stores/expert';

export default {
    name: 'ButtonComponent',

    inheritAttrs: false,
    props: {
        route: {
            type: String,
            required: false,
            default: '',
        },

        variant: {
            type: String,
            default: 'primary',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        prependIcon: {
            type: [String, Function],
            default: '',
        },
        appendIcon: {
            type: [String, Function],
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'default',
        },
        type: {
            type: String,
            default: 'button',
        },
        name: {
            type: String,
            default: '',
        },
    },
    emits: { click: null },
    data: () => ({
        expert: useExpertStore(),
    }),
    computed: {
        buttonStyle() {
            const buttonStyles = {
                primary: {
                    variant: 'flat',
                    classes: 'shadow-sm',
                    color: '#000',
                },
                secondary: {
                    variant: 'outlined',
                    classes: 'border-color-gray shadow-sm',
                    color: '#000',
                },
                gray: {
                    variant: 'flat',
                    classes: 'text-darkGray',
                    color: '#D6D6D6',
                },
                text: {
                    variant: 'text',
                    classes: 'text-darkGray',
                    color: '#D6D6D6',
                },
                error: {
                    variant: 'flat',
                    classes: 'text-white',
                    color: 'error',
                },
            };
            return buttonStyles[this.variant];
        },
    },
    methods: {
        handleButtonClick(event) {
            event.stopPropagation();
            this.$emit('click', event);
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-button {
    letter-spacing: 0.025em;
    text-transform: unset !important;
    color: rgb(255, 255, 255);
    font-size: 0.9375rem;
    min-width: 80px;
    padding-left: 16px;
    padding-right: 16px;
}
</style>
